import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { HisBasic } from "./HisBasic";
import { HisRow, SpwkHisStep } from "./HisRow";
import { SpwkMetaTable } from "./SpwkMetaTable";


export class HisRowParser_B02既往病史 {

  /**
* @param step - 用來區分 是 4既往病史 或 6自覺症狀
* @param 基本檔 - 產生 data_row 時需要填寫的基本資料
* @param meta_table - 用來查詢的資料來源
* 
* @returns 
*/
  static ConvertToHisRow(step: SpwkHisStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): HisRow {

    if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史_噪音作業) {
      // pass;
    } else {
      throw new Error("必須是 既往病史_噪音作業 !!!");
    }

    const data_row: HisRow = new HisRow(基本檔, step.HIS類別代碼);

    data_row.項目 = "1";// B02既往病史 都累積在同一題;

    let q_meta_list = meta_table.FilterQuestions_ByChapter(SpwkUtilV3.CHAPTER_既往病史_噪音作業);

    let 類別List = [];
    for (const q_meta of q_meta_list) {
      if (q_meta.his_code == '32' && q_meta.rhf_value == null) {
        continue;
      } else;
      const his_code = q_meta.his_code;
      const rhf_value = q_meta.rhf_value;

      const o_meta_list = meta_table.FilterOptions_ByQuestionGuid(q_meta.question_guid);

      const opt_meta = o_meta_list.find(x => x.code === rhf_value);

      if (opt_meta == null) {
        類別List.push(his_code + "#" + "");
      } else {
        類別List.push(his_code + "#" + opt_meta.his_code);
      }

    }


    data_row.結果 = 類別List.join("@");
    data_row.備註 = "";

    return data_row;
  }


}